'use es6';

import invariant from './invariant';
export default ((condition, message) => (fn, name = 'function') => (...args) => {
  const warning = typeof message === 'string' ? message : typeof message === 'function' ? message(...args, name) : null;
  invariant(condition(...args), typeof warning === 'string' ? warning : `preconditions failed for ${name} with arguments ${args}`);
  return fn(...args);
});